import api from './apiConfig';

/**
 * Fetch session info for third-party redirect token
 */
export const fetchThirdPartySession = async ({ sessionToken, signal } = {}) => {
  if (!sessionToken) {
    return {
      success: false,
      message: 'Missing session token',
    };
  }

  try {
    console.log('🌐 Third-Party Session: requesting learner data...');
    const response = await api.get('/frontsite-api/v1/third-party/session', {
      params: { s: sessionToken },
      signal,
    });

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    const status = error.response?.status;
    const message =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch third-party session';

    console.error('❌ Third-Party Session Error:', {
      status,
      message,
    });

    return {
      success: false,
      status,
      message,
    };
  }
};
